// extracted by mini-css-extract-plugin
export default {"reportPage":"IR1zP0lh6DpmEuNfd0gN__reportPage___"};